<div class="cpb5" fxLayout="row wrap">
    <div fxFlex="100" fxFlex.lt-md="100">
       <app-hierachie-p-tree
       (searchtree)="onSearch($event)"

       [listTree]="datatree"
      ></app-hierachie-p-tree> 
    </div>
    <div fxFlex="100" fxFlex.lt-md="100">
      <mat-card class="table-card" appCard>
      
        <mat-card-content> 
         
             <app-hierachie-p-table      
            
             (searchid)="onSearch($event)"
             [firsttable]="firsttable"

             [list]="data">
            </app-hierachie-p-table>
            
         
          
        </mat-card-content>
      </mat-card>

    </div>
  </div>
  
